import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "limit-popover"
};
const _hoisted_2 = {
    key: 0,
    class: "limit-table"
};
const _hoisted_3 = { class: "limit-value" };
const _hoisted_4 = { class: "limit-value" };
const _hoisted_5 = { class: "limit-value" };
const _hoisted_6 = { class: "limit-value" };
const _hoisted_7 = {
    key: 1,
    class: "limit-table"
};
const _hoisted_8 = { class: "limit-value" };
const _hoisted_9 = { class: "limit-value" };
const _hoisted_10 = {
    key: 2,
    class: "limit-table"
};
const _hoisted_11 = { class: "limit-value" };
const _hoisted_12 = { class: "limit-value" };
const _hoisted_13 = {
    key: 3,
    class: "limit-table"
};
const _hoisted_14 = { class: "limit-value" };
const _hoisted_15 = {
    key: 4,
    class: "limit-table"
};
const _hoisted_16 = { class: "limit-value" };
const _hoisted_17 = {
    key: 5,
    class: "limit-table"
};
const _hoisted_18 = { class: "limit-value" };
const _hoisted_19 = {
    key: 6,
    class: "limit-table"
};
const _hoisted_20 = { class: "limit-value" };
const _hoisted_21 = {
    key: 7,
    class: "limit-table"
};
const _hoisted_22 = { class: "limit-value" };
const _hoisted_23 = { class: "limit-value" };
const _hoisted_24 = {
    key: 8,
    class: "limit-table"
};
const _hoisted_25 = { class: "limit-value" };
const _hoisted_26 = { class: "limit-value" };
const _hoisted_27 = {
    key: 9,
    class: "clearfix text-center"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_popover = _resolveComponent("b-popover");
    return (_ctx.canShow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_b_popover, {
                target: _ctx.target,
                triggers: "hover",
                "custom-class": `limit`,
                placement: "auto"
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.measurementName), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                    _cache[57] || (_cache[57] = _createTextVNode()),
                    (_ctx.layoutType == _ctx.limitLayoutEnum.All)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
                            _cache[3] || (_cache[3] = _createElementVNode("colgroup", null, [
                                _createElementVNode("col", { class: "limit-value" }),
                                _createTextVNode(),
                                _createElementVNode("col", { class: "limit-value" }),
                                _createTextVNode(),
                                _createElementVNode("col", { class: "limit-value" }),
                                _createTextVNode(),
                                _createElementVNode("col", { class: "limit-value" })
                            ], -1 /* CACHED */)),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { colspan: "4" }, [
                                        _createElementVNode("svg", {
                                            width: "200",
                                            height: "17"
                                        }, [
                                            _createElementVNode("polygon", {
                                                points: "0,7 5,0 25,0 25,17 23,17 23,13 5,13",
                                                class: "critical"
                                            }),
                                            _createTextVNode(),
                                            _createElementVNode("polygon", {
                                                points: "26,0 75,0 75,17 73,17 73,13 26,13",
                                                class: "warning"
                                            }),
                                            _createTextVNode(),
                                            _createElementVNode("polygon", {
                                                points: "76,0 124,0 124,13 76,13",
                                                class: "healthy"
                                            }),
                                            _createTextVNode(),
                                            _createElementVNode("polygon", {
                                                points: "125,0 174,0 174,13 127,13 127,17 125,17",
                                                class: "warning"
                                            }),
                                            _createTextVNode(),
                                            _createElementVNode("polygon", {
                                                points: "175,0 195,0 200,7 195,13 177,13 177,17 175,17",
                                                class: "critical"
                                            })
                                        ])
                                    ])
                                ])
                            ], -1 /* CACHED */)),
                            _cache[6] || (_cache[6] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                    _cache[0] || (_cache[0] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                    _cache[1] || (_cache[1] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                    _cache[2] || (_cache[2] = _createTextVNode()),
                                    _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                ])
                            ])
                        ]))
                        : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerWarningCritical)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_7, [
                                _cache[10] || (_cache[10] = _createElementVNode("colgroup", null, [
                                    _createElementVNode("col", { class: "limit-value" }),
                                    _createTextVNode(),
                                    _createElementVNode("col", { class: "limit-value" }),
                                    _createTextVNode(),
                                    _createElementVNode("col", { class: "limit-spacer" })
                                ], -1 /* CACHED */)),
                                _cache[11] || (_cache[11] = _createTextVNode()),
                                _cache[12] || (_cache[12] = _createElementVNode("thead", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", { colspan: "3" }, [
                                            _createElementVNode("svg", {
                                                width: "130",
                                                height: "17"
                                            }, [
                                                _createElementVNode("polygon", {
                                                    points: "0,7 5,0 25,0 25,17 23,17 23,13 5,13",
                                                    class: "critical"
                                                }),
                                                _createTextVNode(),
                                                _createElementVNode("polygon", {
                                                    points: "26,0 75,0 75,17 73,17 73,13 26,13",
                                                    class: "warning"
                                                }),
                                                _createTextVNode(),
                                                _createElementVNode("polygon", {
                                                    points: "76,0 125,0 130,7 125,13 76,13",
                                                    class: "healthy"
                                                })
                                            ])
                                        ])
                                    ])
                                ], -1 /* CACHED */)),
                                _cache[13] || (_cache[13] = _createTextVNode()),
                                _createElementVNode("tbody", null, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                        _cache[7] || (_cache[7] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                        _cache[8] || (_cache[8] = _createTextVNode()),
                                        _cache[9] || (_cache[9] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */))
                                    ])
                                ])
                            ]))
                            : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningCritical)
                                ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
                                    _cache[17] || (_cache[17] = _createElementVNode("colgroup", null, [
                                        _createElementVNode("col", { class: "limit-spacer" }),
                                        _createTextVNode(),
                                        _createElementVNode("col", { class: "limit-value" }),
                                        _createTextVNode(),
                                        _createElementVNode("col", { class: "limit-value" })
                                    ], -1 /* CACHED */)),
                                    _cache[18] || (_cache[18] = _createTextVNode()),
                                    _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", { colspan: "3" }, [
                                                _createElementVNode("svg", {
                                                    width: "130",
                                                    height: "17"
                                                }, [
                                                    _createElementVNode("polygon", {
                                                        points: "0,7 5,0 54,0 54,13 5,13",
                                                        class: "healthy"
                                                    }),
                                                    _createTextVNode(),
                                                    _createElementVNode("polygon", {
                                                        points: "55,0 104,0 104,13 57,13 57,17 55,17",
                                                        class: "warning"
                                                    }),
                                                    _createTextVNode(),
                                                    _createElementVNode("polygon", {
                                                        points: "105,0 125,0 130,7 125,13 107,13 107,17 105,17",
                                                        class: "critical"
                                                    })
                                                ])
                                            ])
                                        ])
                                    ], -1 /* CACHED */)),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createElementVNode("tbody", null, [
                                        _createElementVNode("tr", null, [
                                            _cache[14] || (_cache[14] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */)),
                                            _cache[15] || (_cache[15] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                            _cache[16] || (_cache[16] = _createTextVNode()),
                                            _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                        ])
                                    ])
                                ]))
                                : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerWarningOnly)
                                    ? (_openBlock(), _createElementBlock("table", _hoisted_13, [
                                        _cache[23] || (_cache[23] = _createElementVNode("colgroup", null, [
                                            _createElementVNode("col", { class: "limit-value" }),
                                            _createTextVNode(),
                                            _createElementVNode("col", { class: "limit-spacer" })
                                        ], -1 /* CACHED */)),
                                        _cache[24] || (_cache[24] = _createTextVNode()),
                                        _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", { colspan: "2" }, [
                                                    _createElementVNode("svg", {
                                                        width: "80",
                                                        height: "17"
                                                    }, [
                                                        _createElementVNode("polygon", {
                                                            points: "0,7 5,0 54,0 54,13 5,13",
                                                            class: "warning"
                                                        }),
                                                        _createTextVNode(),
                                                        _createElementVNode("polygon", {
                                                            points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                                                            class: "healthy"
                                                        })
                                                    ])
                                                ])
                                            ])
                                        ], -1 /* CACHED */)),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.getValue(_ctx.limit.lowerWarningLimit)), 1 /* TEXT */),
                                                _cache[21] || (_cache[21] = _createTextVNode()),
                                                _cache[22] || (_cache[22] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */))
                                            ])
                                        ])
                                    ]))
                                    : (_ctx.layoutType == _ctx.limitLayoutEnum.LowerCriticalOnly)
                                        ? (_openBlock(), _createElementBlock("table", _hoisted_15, [
                                            _cache[29] || (_cache[29] = _createElementVNode("colgroup", null, [
                                                _createElementVNode("col", { class: "limit-value" }),
                                                _createTextVNode(),
                                                _createElementVNode("col", { class: "limit-spacer" })
                                            ], -1 /* CACHED */)),
                                            _cache[30] || (_cache[30] = _createTextVNode()),
                                            _cache[31] || (_cache[31] = _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("th", { colspan: "2" }, [
                                                        _createElementVNode("svg", {
                                                            width: "80",
                                                            height: "17"
                                                        }, [
                                                            _createElementVNode("polygon", {
                                                                points: "0,7 5,0 54,0 54,13 5,13",
                                                                class: "critical"
                                                            }),
                                                            _createTextVNode(),
                                                            _createElementVNode("polygon", {
                                                                points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                                                                class: "healthy"
                                                            })
                                                        ])
                                                    ])
                                                ])
                                            ], -1 /* CACHED */)),
                                            _cache[32] || (_cache[32] = _createTextVNode()),
                                            _createElementVNode("tbody", null, [
                                                _createElementVNode("tr", null, [
                                                    _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                                    _cache[28] || (_cache[28] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */))
                                                ])
                                            ])
                                        ]))
                                        : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningOnly)
                                            ? (_openBlock(), _createElementBlock("table", _hoisted_17, [
                                                _cache[35] || (_cache[35] = _createElementVNode("colgroup", null, [
                                                    _createElementVNode("col", { class: "limit-spacer" }),
                                                    _createTextVNode(),
                                                    _createElementVNode("col", { class: "limit-value" })
                                                ], -1 /* CACHED */)),
                                                _cache[36] || (_cache[36] = _createTextVNode()),
                                                _cache[37] || (_cache[37] = _createElementVNode("thead", null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("th", { colspan: "2" }, [
                                                            _createElementVNode("svg", {
                                                                width: "80",
                                                                height: "17"
                                                            }, [
                                                                _createElementVNode("polygon", {
                                                                    points: "0,7 5,0 54,0 54,13 5,13",
                                                                    class: "healthy"
                                                                }),
                                                                _createTextVNode(),
                                                                _createElementVNode("polygon", {
                                                                    points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                                                                    class: "warning"
                                                                })
                                                            ])
                                                        ])
                                                    ])
                                                ], -1 /* CACHED */)),
                                                _cache[38] || (_cache[38] = _createTextVNode()),
                                                _createElementVNode("tbody", null, [
                                                    _createElementVNode("tr", null, [
                                                        _cache[33] || (_cache[33] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */)),
                                                        _cache[34] || (_cache[34] = _createTextVNode()),
                                                        _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */)
                                                    ])
                                                ])
                                            ]))
                                            : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperCriticalOnly)
                                                ? (_openBlock(), _createElementBlock("table", _hoisted_19, [
                                                    _cache[41] || (_cache[41] = _createElementVNode("colgroup", null, [
                                                        _createElementVNode("col", { class: "limit-spacer" }),
                                                        _createTextVNode(),
                                                        _createElementVNode("col", { class: "limit-value" })
                                                    ], -1 /* CACHED */)),
                                                    _cache[42] || (_cache[42] = _createTextVNode()),
                                                    _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                                                        _createElementVNode("tr", null, [
                                                            _createElementVNode("th", { colspan: "2" }, [
                                                                _createElementVNode("svg", {
                                                                    width: "80",
                                                                    height: "17"
                                                                }, [
                                                                    _createElementVNode("polygon", {
                                                                        points: "0,7 5,0 54,0 54,13 5,13",
                                                                        class: "healthy"
                                                                    }),
                                                                    _createTextVNode(),
                                                                    _createElementVNode("polygon", {
                                                                        points: "55,0 75,0 80,7 75,13 57,13 57,17 55,17",
                                                                        class: "critical"
                                                                    })
                                                                ])
                                                            ])
                                                        ])
                                                    ], -1 /* CACHED */)),
                                                    _cache[44] || (_cache[44] = _createTextVNode()),
                                                    _createElementVNode("tbody", null, [
                                                        _createElementVNode("tr", null, [
                                                            _cache[39] || (_cache[39] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */)),
                                                            _cache[40] || (_cache[40] = _createTextVNode()),
                                                            _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                        ])
                                                    ])
                                                ]))
                                                : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperWarningCritical)
                                                    ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
                                                        _cache[48] || (_cache[48] = _createElementVNode("colgroup", null, [
                                                            _createElementVNode("col", { class: "limit-spacer" }),
                                                            _createTextVNode(),
                                                            _createElementVNode("col", { class: "limit-value" }),
                                                            _createTextVNode(),
                                                            _createElementVNode("col", { class: "limit-value" })
                                                        ], -1 /* CACHED */)),
                                                        _cache[49] || (_cache[49] = _createTextVNode()),
                                                        _cache[50] || (_cache[50] = _createElementVNode("thead", null, [
                                                            _createElementVNode("tr", null, [
                                                                _createElementVNode("th", { colspan: "3" }, [
                                                                    _createElementVNode("svg", {
                                                                        width: "130",
                                                                        height: "17"
                                                                    }, [
                                                                        _createElementVNode("polygon", {
                                                                            points: "0,7 5,0 54,0 54,13 5,13",
                                                                            class: "healthy"
                                                                        }),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("polygon", {
                                                                            points: "55,0 104,0 104,13 57,13 57,17 55,17",
                                                                            class: "warning"
                                                                        }),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("polygon", {
                                                                            points: "105,0 125,0 130,7 125,13 107,13 107,17 105,17",
                                                                            class: "critical"
                                                                        })
                                                                    ])
                                                                ])
                                                            ])
                                                        ], -1 /* CACHED */)),
                                                        _cache[51] || (_cache[51] = _createTextVNode()),
                                                        _createElementVNode("tbody", null, [
                                                            _createElementVNode("tr", null, [
                                                                _cache[45] || (_cache[45] = _createElementVNode("td", { class: "limit-spacer" }, null, -1 /* CACHED */)),
                                                                _cache[46] || (_cache[46] = _createTextVNode()),
                                                                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.getValue(_ctx.limit.upperWarningLimit)), 1 /* TEXT */),
                                                                _cache[47] || (_cache[47] = _createTextVNode()),
                                                                _createElementVNode("td", _hoisted_23, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                            ])
                                                        ])
                                                    ]))
                                                    : (_ctx.layoutType == _ctx.limitLayoutEnum.UpperLowerCritical)
                                                        ? (_openBlock(), _createElementBlock("table", _hoisted_24, [
                                                            _cache[53] || (_cache[53] = _createElementVNode("colgroup", null, [
                                                                _createElementVNode("col", { class: "limit-value" }),
                                                                _createTextVNode(),
                                                                _createElementVNode("col", { class: "limit-value" })
                                                            ], -1 /* CACHED */)),
                                                            _cache[54] || (_cache[54] = _createTextVNode()),
                                                            _cache[55] || (_cache[55] = _createElementVNode("thead", null, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("th", { colspan: "2" }, [
                                                                        _createElementVNode("svg", {
                                                                            width: "130",
                                                                            height: "17"
                                                                        }, [
                                                                            _createElementVNode("polygon", {
                                                                                points: "0,7 5,0 30,0 30,13 5,13",
                                                                                class: "critical"
                                                                            }),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("polygon", {
                                                                                points: "31,0 95,0 95,13 33,13 33,17 31,17",
                                                                                class: "healthy"
                                                                            }),
                                                                            _createTextVNode(),
                                                                            _createElementVNode("polygon", {
                                                                                points: "96,0 126,0 130,7 125,13 98,13 98,17 96,17",
                                                                                class: "critical"
                                                                            })
                                                                        ])
                                                                    ])
                                                                ])
                                                            ], -1 /* CACHED */)),
                                                            _cache[56] || (_cache[56] = _createTextVNode()),
                                                            _createElementVNode("tbody", null, [
                                                                _createElementVNode("tr", null, [
                                                                    _createElementVNode("td", _hoisted_25, _toDisplayString(_ctx.getValue(_ctx.limit.lowerCriticalLimit)), 1 /* TEXT */),
                                                                    _cache[52] || (_cache[52] = _createTextVNode()),
                                                                    _createElementVNode("td", _hoisted_26, _toDisplayString(_ctx.getValue(_ctx.limit.upperCriticalLimit)), 1 /* TEXT */)
                                                                ])
                                                            ])
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_27, "\r\n\t\t\t\t\tThis limit layout is not yet supported.\r\n\t\t\t\t"))
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["target"])
        ]))
        : _createCommentVNode("v-if", true);
}
